import { clearPaymentTransaction } from './actions';
import { clearSelectedOrderLines } from '../order/actions';

export default {
  onVisit: clearPaymentTransaction(),
  onLeave: clearSelectedOrderLines()
};
